import React from 'react';

interface Props { children: React.ReactNode; }
interface State { hasError: boolean; }

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // Log only in dev to avoid leaking details in production console
    if (process.env.NODE_ENV !== 'production') {
      console.error('ErrorBoundary caught:', error, info);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0A1128', color: 'white', textAlign: 'center', padding: 24 }}>
          <div style={{ maxWidth: 480 }}>
            <p style={{ fontFamily: 'var(--font-mono, monospace)', fontSize: 12, color: '#EF5350', letterSpacing: '0.25em', textTransform: 'uppercase', marginBottom: 16 }}>MALUZ TECHNOLOGIES</p>
            <h1 style={{ fontFamily: 'var(--font-heading, sans-serif)', fontSize: 36, fontWeight: 700, marginBottom: 12 }}>Algo correu mal</h1>
            <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.7)', marginBottom: 28, lineHeight: 1.6 }}>
              Ocorreu um erro inesperado. A nossa equipa foi notificada.<br/>
              An unexpected error occurred. Please try again.
            </p>
            <button onClick={() => { window.location.href = '/'; }}
              style={{ padding: '12px 28px', background: '#EF5350', color: 'white', border: 'none', fontWeight: 700, fontSize: 13, cursor: 'pointer', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Voltar ao Início
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
